import { render, staticRenderFns } from "./DiscountCustomersLink.vue?vue&type=template&id=5b57232f&scoped=true"
import script from "./DiscountCustomersLink.vue?vue&type=script&lang=js"
export * from "./DiscountCustomersLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b57232f",
  null
  
)

export default component.exports